//CRN_20251218 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import { DecryptAesClientSide, EncryptAesClientSide } from 'src/app/core/encryption';
import { environment } from 'src/environments/environment';
import { ExceptionsService } from './exceptions-service';
import { Injectable } from '@angular/core';
import { StorageValues } from 'src/app/core/consts';

@Injectable({ providedIn: 'root' })

export class StorageService {
  
  constructor(
    private exceptionsService: ExceptionsService
  ) { }
    
  public clear(): void {
    try {
      if (environment.useSessionStorage==true)
        return sessionStorage.clear();

      return localStorage.clear();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  public clearAll(): void {
    try {
      const setEncSessionEnded: null | string | undefined=DecryptAesClientSide(this.getItem(StorageValues.encSessionEnded));
      
      sessionStorage.clear();

      if (setEncSessionEnded)
        this.setItem(StorageValues.encSessionEnded, EncryptAesClientSide("true"));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  public getItem(key: string): null | string {
    try {
      if (environment.useSessionStorage==true)
        return sessionStorage.getItem(key)

      return localStorage.getItem(key);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return null;
    }
  }
    
  public removeItem(key: string): void {
    try {
      if (environment.useSessionStorage==true)
        return sessionStorage.removeItem(key)

      return localStorage.removeItem(key);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  public setItem(key: string, value: string): void {
    try {
      if (environment.useSessionStorage==true)
        return sessionStorage.setItem(key, value)

      return localStorage.setItem(key, value);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
}
